import { PageProps } from 'gatsby'

import {
  CategoryLayout,
  FilterCategoryLayout,
  FilterSearchLayout,
  FrequentLayout,
  HtmlLayout,
  IconLayout,
  IframeLayout,
  ImportantLayout,
  InformationLayout,
  Layout,
  SearchLayout,
  SearchParams,
} from '@karakuri-web/faq-type'

import { CategoryWidget } from '../CategoryWidget'
import { FaqWidget } from '../FaqWidget'
import { FilterCategoryWidget } from '../FilterCategoryWidget'
import { FilterSearchWidget } from '../FilterSearchWidget'
import { HtmlWidget } from '../HtmlWidget'
import { IconWidget } from '../IconWidget'
import { IframeWidget } from '../IframeWidget'
import { ImportantWidget } from '../ImportantWidget'
import { InformationWidget } from '../InformationWidget'
import { Data } from '../interface'
import { SearchWidget } from '../SearchWidget'

export type Props = Pick<
  PageProps<Data, Record<string, unknown>, SearchParams>,
  'data' | 'location'
>

export function renderIndexPageWidget(layouts: readonly Layout[], { data, location }: Props) {
  return layouts.map(layout => {
    switch (layout.type) {
      case 'information': {
        return (
          <InformationWidget key={layout.id} layout={layout as InformationLayout} data={data} />
        )
      }
      case 'important': {
        return <ImportantWidget key={layout.id} layout={layout as ImportantLayout} data={data} />
      }
      case 'search': {
        return <SearchWidget key={layout.id} layout={layout as SearchLayout} data={data} />
      }
      case 'frequent': {
        return <FaqWidget key={layout.id} layout={layout as FrequentLayout} data={data} />
      }
      case 'category': {
        return <CategoryWidget key={layout.id} layout={layout as CategoryLayout} data={data} />
      }
      case 'icon': {
        return <IconWidget key={layout.id} layout={layout as IconLayout} />
      }
      case 'filterSearch': {
        return (
          <FilterSearchWidget
            key={layout.id}
            layout={layout as FilterSearchLayout}
            tags={[]}
            q={[]}
            data={data}
            location={location}
          />
        )
      }
      case 'filterCategory': {
        return (
          <FilterCategoryWidget
            key={layout.id}
            layout={layout as FilterCategoryLayout}
            dictionary={{}}
            location={location}
            pageContext={{ category: { sub: data.settingYaml.categories } } as any}
            data={data}
          />
        )
      }
      case 'html': {
        return <HtmlWidget key={layout.id} layout={layout as HtmlLayout} />
      }
      case 'iframe': {
        return <IframeWidget key={layout.id} layout={layout as IframeLayout} />
      }
      default: {
        return null
      }
    }
  })
}
